/* eslint react/no-string-refs: "off" */

import React from 'react';
import * as _ from 'lodash';
import moment from 'moment';

import fetchMg from '../utilities/fetchManager';
import EventMg from '../utilities/EventManager';
import { Table } from '../components/CommonTable';
import { DragSourceAndDropTarget } from '../components/DnDWrapper';
import DocumentDelegate from '../utilities/DocumentDelegate';
import dialogLoader from '../utilities/dialogLoader';
import * as api from '../services/FieldTree';
import * as dialog from '../components/FieldTreeDialog';
import { FIELD_TREE_EVENTS } from '../components/FieldTreeEvents';
import FieldTreeConstructorBoxEvents, {
  FIELD_TREE_CONSTRUCTOR_BOX,
} from '../components/FieldTreeConstructorBoxEvents';
import {
  USER_ROLES,
  HEADER_CONSTANTS,
  DISPLAY_FLAG,
  API_FLAG,
  USER_BOX_STATUS,
  DATE_TIME_FORMAT,
} from '../utilities/constants';
import { csvDownloader } from '../utilities/commonUtil';
import { CompanyBranchDropdown } from '../components/dropdowns/single/CompanyBranch';
import { TouchDeviceInvisible } from '../components/TouchDeviceInvisible';
import Confirmation from '../components/modals/common/Confirmation';
import { messageUtility } from '../utilities/messageUtility';
import Helmet from 'react-helmet';
import masterSlideLoader from '../utilities/masterSlideLoader';
import { FieldTreeService } from '../services/FieldTrees';
import { MasterPageHeader } from '../components/PageHeader';
import LocalStorageService from '../services/utilities/LocalStorageService';
import SessionStorageService from '../services/utilities/SessionStorageService';
import { isBranchRoleId, isPrimeRoleId } from '../utilities/roleUtility';
import FieldContractorUsers, {
  FieldContractorUserService,
} from '../services/FieldContractorUsers';

/**
 * @description 施工体系図 現場監督一覧 ページ
 */
export default class FieldTreeContractorBox extends React.Component {
  constructor(props) {
    super(props);

    const decoded = JSON.parse(decodeURIComponent(this.props.view.state.id));
    const params = {
      offset: 0,
      limit: 30,
      updated: 0, //ユーザの更新
      refresh: 0, //テーブルリフレッシュ用のカウンター
      request_from_contractor_box: true,
    };
    this.state = {
      params, // 絞り込み処理で更新するので stateで保持
      tempParams: _.cloneDeep(params), //検索条件(保存用)
      refresh: 0,
      company: {}, //会社情報
      data: [], //一覧データ
      copy_data: [], //一覧データのコピー
      master: {}, //マスター情報
      field_id: sessionStorage.getItem('field_id'),
      search_form_open: true, // search_form の開閉
      edit_user_id: null, //編集するユーザーのid
      company_branch_id: decoded.id || null, //選択した会社のid
      jv_id: decoded.jvcbid, //JVのcompany_branch_id
      jv: {},
      canSort: false, //ドラッグアンドドロップしない
      paramReset: 0, //絞り込みリセット
      menuViewFlg: true,
      showDragItem: true,
      shitenFlag: true,
      foremanFlag: true,
      dialog_show: false, // ダイアログフラグ
      isLoading: true, // ロード中フラグ
      isFetch: false, // 再読み込みフラグ
      isNewSearch: false, // 検索ボタン押下時のフラグ(BLDE_V2-41384)
      selectedBranch: {
        id: null,
        name: '',
      },
    };

    this.total = 0; // 検索結果件数を保持
    this.multiselectform = [];

    this.searchFormRef = null;
    this.searchButtonRef = React.createRef(); // 検索ボタン要素
    this.Shiten = null;
    this.clearFlag = false;
    this.checkDialogNeed = this.checkDialogNeed.bind(this);
    this.userId = LocalStorageService.getUserId();
    this.roleId = LocalStorageService.getRoleId();
    this.isSubmittingFlag = false;
    this.isRequestingFlag = false;
    this.userChangeStatus = {
      id: null,
      blockedAt: null,
      isEditMySelf: false,
      isBuildeeUser: false,
      isExistRelativeData: false,
    };
    //現場情報
    EventMg.addEventListener(FIELD_TREE_EVENTS.TREE_FIELD, data => {
      this.setState({ field_data: data.entities.field });
    });

    // search formを開閉させる。
    EventMg.addEventListener(
      FIELD_TREE_CONSTRUCTOR_BOX.SEARCH_FORM_OPEN,
      () => {
        this.setState({ search_form_open: !this.state.search_form_open });
      }
    );

    // 検索条件をクリア
    EventMg.addEventListener(FIELD_TREE_CONSTRUCTOR_BOX.SEARCH_CLEAR, () => {
      this.clearFlag = true;
      _.each(this.searchFormRef.querySelectorAll('input'), input => {
        input.checked = null;
        input.value = null;
      });
      if (this.Shiten) {
        this.Shiten.resetValue();
      }
      const params = {
        offset: 0,
        limit: 30,
        updated: this.state.params.updated,
        paramReset: this.state.paramReset + 1,
        request_from_contractor_box: true,
        _,
      };
      this.setState({
        data: [],
        params,
        tempParams: _.cloneDeep(params),
        showDragItem: true,
        shitenFlag: true,
        foremanFlag: true,
        isLoading: true,
        isFetch: true,
        isNewSearch: true,
        selectedBranch: { id: null, name: '' },
      });
      EventMg.trigger(FIELD_TREE_CONSTRUCTOR_BOX.CHANGE_FORM_SHOW, null);
    });

    // 編集ボタンを押したときの処理
    EventMg.addEventListener(
      FIELD_TREE_CONSTRUCTOR_BOX.CHANGE_FORM_SHOW,
      data => {
        if (data) {
          this.setState({ edit_user_id: data.id });
          return;
        }
        this.setState({ edit_user_id: null });
      }
    );

    // ドラッグアンドドロップ
    // eslint-disable-next-line no-unused-vars
    EventMg.addEventListener(FIELD_TREE_CONSTRUCTOR_BOX.DRAG_ITEM, () => {
      this.setState({ canSort: !this.state.canSort });
    });

    EventMg.addEventListener(FIELD_TREE_CONSTRUCTOR_BOX.ORDER_UPDATE, data => {
      this.setState({ copy_data: data });
    });

    // 並び順を保存
    // eslint-disable-next-line no-unused-vars
    EventMg.addEventListener(
      FIELD_TREE_CONSTRUCTOR_BOX.SAVE_ORDER,
      save_flag => {
        if (save_flag === true) {
          this.saveOrder();
        }
        this.setState({ canSort: false });
      }
    );

    //新規作成
    EventMg.addEventListener(FIELD_TREE_CONSTRUCTOR_BOX.NEW_FORM, () => {
      let _param = {
        prev_id: this.state.field_tree_id,
        company_branch_id: this.state.company_branch_id,
        main_branch_id: FieldTreeService.decideCompanyBranchId(
          this.state.field_data,
          this.state.company_branch_id
        ),
        jvcbid: this.state.jv_id
          ? this.state.jv_id
          : this.state.company_branch_id,
        jv_company_branch_id: this.state.company_branch_id,
      };
      const json = encodeURIComponent(JSON.stringify(_param));
      masterSlideLoader.show(
        'FieldTreeNew',
        { state: { id: json } },
        this.props.vw
      );
    });

    //追加
    EventMg.addEventListener(
      FIELD_TREE_CONSTRUCTOR_BOX.ADD_FROM_SEARCH,
      param => {
        let _param = {
          prev_id: this.state.company_branch_id,
          // 検索した支店はあくまでユーザー絞り込み用。登録ユーザーが紐づく支店は施工体系図で選択した支店で決まるよう修正
          //company_branch_id: param.company_branch_id,
          company_branch_id: this.state.company_branch_id,
          //main_branch_id: this.getCompanyBranchId(),
          main_branch_id: FieldTreeService.decideCompanyBranchId(
            this.state.field_data,
            this.state.company_branch_id
          ),
          constructor_user_id: param.constructor_user_id,
          jvcbid: this.state.jv_id ? this.state.jv_id : param.company_branch_id,
          jv_company_branch_id: this.state.company_branch_id,
        };
        const json = encodeURIComponent(JSON.stringify(_param));
        masterSlideLoader.show(
          'FieldTreeNew',
          {
            state: { id: json },
          },
          this.props.vw
        );
        dialogLoader.close();
      }
    );

    //ユーザの削除
    EventMg.addEventListener(FIELD_TREE_CONSTRUCTOR_BOX.DELETE_USER, data => {
      dialogLoader.show(dialog.DeleteConstructorUser, {
        callback: {
          close: () => {
            dialogLoader.close();
          },
          delete: () => {
            EventMg.trigger(FIELD_TREE_CONSTRUCTOR_BOX.CHANGE_FORM_SHOW, null);
            this.deleteUser(data);
            dialogLoader.close();
          },
        },
      });
    });

    //ユーザ情報の更新
    EventMg.addEventListener(FIELD_TREE_CONSTRUCTOR_BOX.UPDATE_FORM, data => {
      this.updateUser(data);
    });

    //CSV
    // eslint-disable-next-line no-unused-vars
    EventMg.addEventListener(FIELD_TREE_CONSTRUCTOR_BOX.CSV_EXPORT, data => {
      dialogLoader.show(dialog.CSVExportPartnerAdmin, {
        state: {
          fieldId: this.state.field_id,
        },
        callback: {
          csvDownloadPreparation: () => {
            let params = _.cloneDeep(this.state.params) || {};
            params = _.omit(params, ['offset', 'limit', 'updated', 'refresh']);
            params.jv_company_branch_id = this.state.company_branch_id;
            const apiPath = `api/private/fields/${this.state.field_id}/field_contractor_users/list.csv`;

            csvDownloader(apiPath, params);
          },
          close: () => {
            dialogLoader.close();
          },
        },
      });
    });
  }

  eventBind() {
    //リフレッシュ
    EventMg.addEventListener(FIELD_TREE_CONSTRUCTOR_BOX.REFRESH_LIST, () => {
      this.setState({
        params: {
          refresh: this.state.params.refresh + 1,
          request_from_contractor_box: true, //[BLDE_V2-47744] 初期表示と同じように停止アカウントも取得
        },
        isFetch: true,
      });
    });
  }

  eventUnBind() {
    EventMg.deleteEvent(FIELD_TREE_CONSTRUCTOR_BOX.REFRESH_LIST);
  }

  componentDidUpdate() {
    if (this.clearFlag === true) {
      this.clearFlag = false;
    }
  }

  componentDidMount() {
    DocumentDelegate.init();
    this.eventBind();
    this.FieldData();
    this.getConstructorData();
    this.radioButtonInit();
    this.dropDownInit();
    this.getMasterTable();
  }

  componentWillUnmount() {
    FieldTreeConstructorBoxEvents.removeAll();
    this.eventUnBind();
  }

  /**
   *
   */
  async getConstructorData() {
    const data = await api.FieldTreeList(this.state.field_id, {
      limit: 1,
      offset: 0,
    });
    if (data) {
      this.setState({
        company: data.entities.prime_contractor_company_branch,
      });
    }
  }

  /**
   * マスター情報
   */
  async getMasterTable() {
    await this.FieldData();
    //役職情報
    const positionEntities = await api.PositionList(
      FieldTreeService.decideCompanyBranchId(
        this.state.field_data,
        this.state.company_branch_id
      ),
      DISPLAY_FLAG.use.id,
      API_FLAG.On
    );
    if (positionEntities) {
      let master = _.cloneDeep(this.state.master);
      master.positions = positionEntities.positions;
      this.setState({ master });
    }

    //JV情報
    if (this.state.jv_id) {
      const JVLists = await api.JVListsData(this.state.field_id);
      if (JVLists.entities.company.length) {
        let _jv = _.filter(JVLists.entities.company, c => {
          return c.company_branch_id === this.state.jv_id;
        });
        this.setState({ jv: _jv[0] });
      }
    }
  }

  //現場
  async FieldData() {
    const field = await api.FieldData(this.state.field_id);
    if (field) {
      // EventMg.trigger(FIELD_TREE_EVENTS.TREE_FIELD, field);
      let _state = { ...this.state };
      _state.field_data = field.entities.field;
      this.setState(_state);
    }
  }

  /**
   * ユーザ情報更新
   */
  async updateUser(param) {
    if (this.isRequestingFlag) {
      return;
    }
    this.isRequestingFlag = true;
    const _param = {
      position_id: parseInt(param.position_id),
      approval_flag: parseInt(param.approval_flag),
      approval_level: parseInt(param.approval_level),
      block_flag: parseInt(param.block_flag),
    };

    const data = await fetchMg
      .PatchAjax(
        `/api/private/fields/${this.state.field_id}/field_contractor_users/${param.id}`,
        _param
      )
      .catch(error => {
        switch (error[0].status) {
          case 404: {
            return window.location.replace('/error-permission');
          }
          default: {
            return { result: false };
          }
        }
      });
    this.isRequestingFlag = false;
    if (data.result) {
      var index = _.findIndex(this.state.data, { id: param.id });
      let _data = _.cloneDeep(this.state.data);
      _data.splice(index, 1, _.clone(data.data.entities.field_contractor_user));
      let _params = _.cloneDeep(this.state.params);
      _params.updated = this.state.params.updated + 1;
      this.setState({ params: _params, isFetch: true, data: _data });
      EventMg.trigger(FIELD_TREE_CONSTRUCTOR_BOX.CHANGE_FORM_SHOW, null);
    }
  }

  /**
   * ユーザ削除
   */
  async deleteUser(param) {
    const data = await fetchMg
      .DeleteAjax(
        `/api/private/fields/${this.state.field_id}/field_contractor_users/${param.id}`,
        {}
      )
      .catch(error => {
        switch (error[0].status) {
          case 404: {
            return window.location.replace('/error-permission');
          }
          default: {
            return { result: false };
          }
        }
      });
    if (data.result) {
      EventMg.trigger(FIELD_TREE_CONSTRUCTOR_BOX.CHANGE_FORM_SHOW, null);
    } else {
      const isPrimeContractorHasRegisteredError =
        data.message === '作業元請担当に登録されている為、削除できません。';
      const message = isPrimeContractorHasRegisteredError ? (
        <React.Fragment>
          <span>
            各種予定の元請担当者に設定されているため削除できません。
            <br />
          </span>
          <span>
            各種予定の元請担当者から外すことで削除可能になります。
            <br />
          </span>
          <span>
            過去データを編集できない場合には、ステータスを作業終了に変更してください。作業終了に変更することで、現場へアクセスできなくなります。
          </span>
        </React.Fragment>
      ) : (
        data.message
      );
      const title = isPrimeContractorHasRegisteredError && '削除できません';
      dialogLoader.show(dialog.submitErrorMessage, {
        callback: {
          done: () => {
            dialogLoader.close();
          },
        },
        className: 'SubmitErrorMessageDialog',
        message,
        title,
      });
    }
    EventMg.trigger(FIELD_TREE_CONSTRUCTOR_BOX.REFRESH_LIST);
  }

  /**
   * @description 検索実行
   */
  searchExecution = () => {
    this.searchButtonRef.current.disabled = true;

    this.setState({
      params: _.cloneDeep(this.state.tempParams),
      isFetch: true,
      isLoading: true,
      isNewSearch: true,
    });
  };

  /**
   *
   */
  saveOrder() {
    let _param = {};
    _param.field_contractor_users = _.map(
      this.state.copy_data,
      (val, index) => {
        return {
          id: val.id,
          order_number: index,
        };
      }
    );

    const data = FieldContractorUserService.updateOrder(
      this.state.field_id,
      _param
    )
      .then(() => {
        EventMg.trigger(FIELD_TREE_CONSTRUCTOR_BOX.SEARCH_CLEAR);
      })
      .catch(() => ({ result: false }));

    if (data.result) {
      /* nop */
    }
    this.setState({ data: this.state.copy_data });
  }

  /**
   * @description ドロップダウンに関する初期化処理
   */
  dropDownInit() {
    EventMg.addEventListener(FIELD_TREE_CONSTRUCTOR_BOX.DROPDOWN_VALUE, arg => {
      this.dropdownCallback(arg);
      if (arg[1] === 'user_id' && arg[2] !== 'clear') {
        this.setState({
          foremanFlag: false,
        });
      } else if (arg[1] === 'company_branch_id' && arg[2] !== 'clear') {
        this.setState({
          shitenFlag: false,
        });
      }
      this.setState({ showDragItem: false, isLoading: false, isFetch: false });
    });
  }

  /**
   * ドロップダウンのコールバック
   * @param {dom} element
   * @param {string} name
   * @param {*} value
   */
  dropdownCallback(arg) {
    const name = arg[1];
    const value = arg[2];
    if (value === 'clear') {
      if (name === 'company_branch_id') {
        this.Shiten.resetValue();
        this.setState({ shitenFlag: true });
      }
      if (this.state.shitenFlag === true) {
        this.setState({ showDragItem: true });
      }
    }

    if (name && !value) {
      return;
    }
    let params = _.clone(this.state.tempParams);
    if (name === 'fields') {
      params['name'] = value;
    } else if (name === 'user_id') {
      params['name'] = value.user_name;
    } else if (name === 'company_branch_id') {
      params['company_branch_id'] = value;
    }
    // if ( name === 'company_branch_id') {
    //   params['company_branch_ids'] = _.map(value, v => {return parseInt(v)})}
    // if ( name === 'user_id ') {
    //   params['user_ids'] = [arg[2].user_id]}
    else {
      params[name] = value;
    }

    if (params) {
      this.setState({
        data: [],
        paramReset: this.state.paramReset + 1,
        tempParams: params,
      });
    }
  }

  /**
   * @description ラジオボタンに関する初期化処理
   */
  radioButtonInit() {
    EventMg.addEventListener(
      FIELD_TREE_CONSTRUCTOR_BOX.SEARCH_FORM_RADIO,
      (name, value) => {
        if (_.isString(name) && _.isNumber(value)) {
          const params = _.clone(this.state.tempParams);
          params[name] = value;
          this.setState({
            data: [],
            paramReset: this.state.paramReset + 1,
            isLoading: false,
            isFetch: false,
            tempParams: params,
            showDragItem: false,
          });
        }
      }
    );
  }

  /**
   * @description table itemのデータを追加ロードする
   * @param {Array|Any} stateData 取得したデータ一覧
   */
  async fieldItemLoad(stateData) {
    const params = _.clone(this.state.params);
    if (_.isArray(stateData)) {
      params.offset = stateData.length;
    }
    if (stateData.length < this.state.limit) {
      params.offset = 0;
    }
    // if (this.state.jv_id) params.jv_company_branch_id = this.state.jv_id;
    if (this.state.company_branch_id) {
      params.jv_company_branch_id = this.state.company_branch_id;
    }

    const data = await fetchMg
      .GetAjax(
        `/api/private/fields/${this.state.field_id}/field_contractor_users/list`,
        params
      )
      .catch(() => ({ result: false }));

    if (data.result) {
      this.total = data.data.total; // 検索結果件数を取得

      let _data = [...this.state.data];
      _data.push(...data.data.entities.field_contractor_users);
      _data = _.sortBy(data.data.entities.field_contractor_users, user => {
        return user.order_number;
      });
      _data = _.sortBy(_data, user => {
        return user.block_flag;
      });
      this.setState({
        data: _data,
        isLoading: false,
        isFetch: false,
        isNewSearch: false,
      });
      if (this.searchButtonRef.current) {
        this.searchButtonRef.current.disabled = false;
      }
      return _data || [];
    }

    this.setState({ data: [], isLoading: false, isFetch: false });
    return [];
  }

  /**
   * 絞り込みフォーム
   * @param {bool} isOpen
   * @param {int} total
   * @param {int} fieldId
   */
  getSearchForm(isOpen, total, fieldId, viewFlg) {
    return (
      <div
        ref={e => {
          this.searchFormRef = e;
        }}
        className='master-slide-view__searchform'
      >
        {viewFlg ? (
          <div className='search-form'>
            <SearchFormHeader isOpen={isOpen} total={total} />
            <div
              id='search-form-accordion'
              className={isOpen ? 'accordion show' : 'accordion'}
            >
              <div className='search-form__body set-width-dropdown'>
                <div className='form form--search-form'>
                  <div className='form__group flex-wrap'>
                    <div className='form-element'>
                      <div className='form-element__label'>
                        <span className='label'>支店</span>
                      </div>
                      <div className='form-element__element'>
                        <CompanyBranchDropdown
                          name='company_branch_id'
                          value={this.state.selectedBranch.id}
                          set={(setkey, id) => {
                            this.setState(
                              {
                                tempParams: {
                                  ...this.state.tempParams,
                                  company_branch_id: id,
                                },
                                selectedBranch: {
                                  id,
                                },
                              },
                              () => {
                                EventMg.trigger(
                                  FIELD_TREE_CONSTRUCTOR_BOX.DROPDOWN_VALUE,
                                  [null, setkey, id]
                                );
                              }
                            );
                          }}
                          setkey='company_branch_id'
                          isOptional={true}
                          clearFlag={this.clearFlag}
                        />
                      </div>
                    </div>
                    <SearchFormElement
                      label='Buildee利用'
                      eleClass='form-element__element'
                    >
                      <SearchFormRadio
                        label={USER_ROLES.branch.name}
                        name='role_code'
                        checked={
                          this.state.tempParams['role_code'] ===
                          USER_ROLES.branch.id
                        }
                        value={USER_ROLES.branch.id}
                      />
                      <SearchFormRadio
                        label={USER_ROLES.manager.name}
                        name='role_code'
                        checked={
                          this.state.tempParams['role_code'] ===
                          USER_ROLES.manager.id
                        }
                        value={USER_ROLES.manager.id}
                      />
                    </SearchFormElement>
                    <SearchFormElement
                      label='現場監督'
                      eleClass='form-element__element'
                    >
                      <div className='element__item'>
                        <input
                          name='name'
                          placeholder='現場監督名を入力'
                          type='text'
                          onChange={e => {
                            this.setState({
                              tempParams: {
                                ...this.state.tempParams,
                                name: e.target.value,
                              },
                              showDragItem: e.target.value === '',
                              isLoading: false,
                              isFetch: false,
                            });
                          }}
                        />
                      </div>
                    </SearchFormElement>
                    <SearchFormElement
                      label='ステータス'
                      eleClass='form-element__element'
                    >
                      <SearchFormRadio
                        label={USER_BOX_STATUS.active.text}
                        name='field_contractor_user_block_flag'
                        checked={
                          this.state.tempParams[
                            'field_contractor_user_block_flag'
                          ] === USER_BOX_STATUS.active.value
                        }
                        value={USER_BOX_STATUS.active.value}
                      />
                      <SearchFormRadio
                        label={USER_BOX_STATUS.deactivate.text}
                        name='field_contractor_user_block_flag'
                        checked={
                          this.state.tempParams[
                            'field_contractor_user_block_flag'
                          ] === USER_BOX_STATUS.deactivate.value
                        }
                        value={USER_BOX_STATUS.deactivate.value}
                      />
                      <SearchFormRadio
                        label={USER_BOX_STATUS.blocked.text}
                        name='field_contractor_user_block_flag'
                        checked={
                          this.state.tempParams[
                            'field_contractor_user_block_flag'
                          ] === USER_BOX_STATUS.blocked.value
                        }
                        value={USER_BOX_STATUS.blocked.value}
                      />
                    </SearchFormElement>
                    <SearchFormElement eleClass='form-element__element'>
                      <button
                        className='btn-fixedsize--stay search-form__btn--align-to-element'
                        onClick={this.searchExecution}
                        ref={this.searchButtonRef}
                      >
                        検索
                      </button>
                    </SearchFormElement>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : null}
      </div>
    );
  }

  checkDialogNeed() {
    if (this.state.canSort) {
      this.setState({ dialog_show: true });
    } else {
      EventMg.trigger(FIELD_TREE_EVENTS.TREE_REFRESH);
      masterSlideLoader.show(
        'FieldTreePage',
        { state: { id: 1 } },
        this.props.vw
      );
    }
  }

  handleOpenPopupChangeStatus = data => {
    const status = _.get(data, 'blocked_at')
      ? USER_BOX_STATUS.deactivate.value
      : USER_BOX_STATUS.active.value;

    if (this.canDrag) {
      return;
    }
    //dialog change status
    dialogLoader.show(dialog.ConfirmEditStatus, {
      value: status,
      callback: {
        back: () => {
          dialogLoader.close();
        },
        save: () => {
          this.handleConfirmChangeStatus(data, status);
        },
      },
    });
  };

  /**
   * Handle confirm update status user
   * @param data { object }: user info
   * @param status { number }: 0 | 1
   */
  handleConfirmChangeStatus = async (data, status) => {
    // check admin of main branch
    if (
      isBranchRoleId(data.role_code) &&
      this.state.jv_id === data.company_branch_id
    ) {
      return dialogLoader.show(dialog.AdminOfJVDialog, {
        callback: {
          onClose: () => {
            dialogLoader.close();
          },
        },
      });
    }
    const blockedAt =
      status === USER_BOX_STATUS.deactivate.value
        ? null
        : moment().format(DATE_TIME_FORMAT.slashDateTimeSecondFormat);
    this.userChangeStatus.id = data.id;
    this.userChangeStatus.blockedAt = blockedAt;
    if (blockedAt) {
      if (this.isSubmittingFlag) {
        return;
      }
      this.isSubmittingFlag = true;
      const isExistRelativeData = await this.checkExistRelativeData(data.id);
      this.isSubmittingFlag = false;

      this.userChangeStatus = {
        ...this.userChangeStatus,
        isEditMySelf: this.userId === data.user_id,
        isBuildeeUser:
          data.user_id === _.get(this.state, 'field_data.buildee_user_id'),
        isExistRelativeData,
      };
      if (this.userChangeStatus.isBuildeeUser) {
        return this.showBuildeeUserDialog();
      }
      if (this.userChangeStatus.isEditMySelf) {
        return this.showChangeMyStatusDialog();
      }
      if (isExistRelativeData) {
        return this.showExistRelativeDataDialog();
      }
    }
    await this.updateStatus();
    dialogLoader.close();
  };

  checkExistRelativeData = async fieldContractorUserId => {
    const response = await FieldContractorUsers.checkExistRelativeBuildeeData(
      this.state.field_id,
      fieldContractorUserId
    );
    return _.get(response, 'data.entities.has_relative_buildee_data');
  };

  /**
   * Call api update status user
   * @param callbackRedirect { function | null}
   */
  updateStatus = async (callbackRedirect = null) => {
    if (this.isSubmittingFlag) {
      return;
    }
    this.isSubmittingFlag = true;
    const response = await FieldContractorUsers.updateStatusUser(
      this.state.field_id,
      this.userChangeStatus.id,
      { blocked_at: this.userChangeStatus.blockedAt }
    );
    if (response.result) {
      if (_.isFunction(callbackRedirect)) {
        dialogLoader.close();
        return callbackRedirect();
      }
      const params = _.cloneDeep(this.state.params);
      params.updated = params.updated + 1;
      this.isSubmittingFlag = false;
      return this.setState({ params, isFetch: true });
    }
    return window.location.replace('/error-permission');
  };

  /**
   * Show dialog confirm exist relative data
   */
  showExistRelativeDataDialog = () => {
    const afterBlockDate = moment(this.userChangeStatus.blockedAt)
      .add(1, 'days')
      .format(DATE_TIME_FORMAT.slashDateFormat);
    let redirectToFieldList;
    if (this.userChangeStatus.isEditMySelf) {
      redirectToFieldList = this.redirectToFieldList;
    }

    return dialogLoader.show(dialog.ExistRelativeDataDialog, {
      afterBlockDate,
      callback: {
        onCancel: () => {
          if (this.isSubmittingFlag) {
            return;
          }
          dialogLoader.close();
        },
        onConfirm: async () => {
          await this.updateStatus(redirectToFieldList);
          dialogLoader.close();
        },
      },
    });
  };

  /**
   * Show dialog confirm change status your self
   */
  showChangeMyStatusDialog = () => {
    let handleConfirm = () => this.updateStatus(this.redirectToFieldList);
    if (this.userChangeStatus.isExistRelativeData) {
      handleConfirm = this.showExistRelativeDataDialog;
    }

    return dialogLoader.show(dialog.ChangeMyStatusDialog, {
      callback: {
        onCancel: () => {
          if (this.isSubmittingFlag) {
            return;
          }
          dialogLoader.close();
        },
        onConfirm: () => {
          handleConfirm();
        },
      },
    });
  };

  /**
   * Show dialog confirm change status buidlee user
   */
  showBuildeeUserDialog = () => {
    let handleConfirm = async () => {
      await this.updateStatus();
      dialogLoader.close();
    };
    if (this.userChangeStatus.isEditMySelf) {
      handleConfirm = this.showChangeMyStatusDialog;
    } else if (this.userChangeStatus.isExistRelativeData) {
      handleConfirm = this.showExistRelativeDataDialog;
    }

    return dialogLoader.show(dialog.BuildeeUserDialog, {
      callback: {
        onCancel: () => {
          if (this.isSubmittingFlag) {
            return;
          }
          dialogLoader.close();
        },
        onConfirm: () => {
          handleConfirm();
        },
      },
    });
  };

  /**
   * Clear field And redirect to list field
   */
  redirectToFieldList = () => {
    SessionStorageService.removeInformationRelatedToField();
    window.location.replace('/conference/Fields/0/0/0/0');
  };

  render() {
    const { dialog_show, isLoading, isFetch, isNewSearch } = this.state;
    return (
      <div className='master-slide-view show'>
        <Helmet>
          <title>{HEADER_CONSTANTS.conference} - 施工体系図</title>
        </Helmet>
        <div className='master-slide-view__view'>
          <TitleHeader
            vw={this.props.vw}
            company={this.state.company}
            jv={this.state.jv}
            close={this.checkDialogNeed}
          />
          <div id='infinityscroll-target' className='master-slide-view__table'>
            <HeaderMenu
              vw={this.props.vw}
              canDrag={this.state.canSort}
              fieldId={this.state.field_id}
              companyBranchId={this.state.company_branch_id}
              menuView={() =>
                this.setState({ menuViewFlg: !this.state.menuViewFlg })
              }
              showDragItem={this.state.showDragItem}
            />
            {this.getSearchForm(
              this.state.search_form_open,
              this.total,
              this.state.field_id,
              this.state.menuViewFlg
            )}
            <div className='master-slide-view__body' id='infinityscroll-target'>
              <div className='fieldtree__list'>
                <EditTable
                  canSort={this.state.canSort}
                  refresh={this.state.refresh}
                  paramReset={this.state.paramReset}
                  parentId='infinityscroll-target'
                  onLoad={this.fieldItemLoad.bind(this)}
                  // eslint-disable-next-line no-unused-vars
                  header={props => (
                    <TableHeader fieldId={this.state.field_id} />
                  )}
                  body={props => (
                    <TableItem
                      {...props}
                      canDrag={this.state.canSort}
                      handleOpenPopupChangeStatus={
                        this.handleOpenPopupChangeStatus
                      }
                      editUserId={this.state.edit_user_id}
                    />
                  )}
                  editItem={props => (
                    <EditTableItem {...props} canDrag={this.state.canSort} />
                  )}
                  edituserid={this.state.edit_user_id}
                  master={this.state.master}
                  list_data={this.state.data}
                  isLoading={isLoading}
                  isFetch={isFetch}
                  isNewSearch={isNewSearch}
                />
              </div>
            </div>
          </div>
        </div>
        <Confirmation
          visible={dialog_show === true}
          title={messageUtility.getMessage('I-000-closeEditWindow')}
          message={messageUtility.getMessage('I-000-confirmCloseEditWindow')}
          confirmButtonText={messageUtility.getMessage('I-000-closeEditWindow')}
          cancelButtonText={messageUtility.getMessage('I-000-008')}
          isNegative={true}
          isVerticalButton={true}
          onConfirm={() => {
            EventMg.trigger(FIELD_TREE_CONSTRUCTOR_BOX.SAVE_ORDER, false);
            EventMg.trigger(FIELD_TREE_CONSTRUCTOR_BOX.SEARCH_CLEAR);
            this.setState({
              menuViewFlg: !this.state.menuViewFlg,
              canSort: !this.state.canSort,
              dialog_show: false,
            });
          }}
          onCancel={() => this.setState({ dialog_show: false })}
        />
      </div>
    );
  }
}

class EditTable extends Table {
  constructor(props) {
    super(props);
  }

  defaultItem(param) {
    return this.props.body(param);
  }

  editItem(param) {
    return this.props.editItem(param);
  }

  //ここで並び替え後のリストを取得してコールバックする
  sortList(dragIndex, to_index) {
    super.sortList(dragIndex, to_index);
    EventMg.trigger(
      FIELD_TREE_CONSTRUCTOR_BOX.ORDER_UPDATE,
      this.state.list_data
    );
  }

  /**
   * 削除
   */
  deleteItem(user_id) {
    let _data = this.state.list_data;
    _data = _.remove(_data, item => {
      return item.user_id != user_id;
    });
    this.setState({ list_data: _data });
  }

  setBody() {
    const dragable = _.filter(this.state.list_data, data => {
      return data.id == this.props.edituserid;
    }).length
      ? false
      : true;
    if (this.props.body) {
      return _.map(this.state.list_data, (data, i) => {
        const key = `${this.id}-${i}`;
        const editable = this.props.edituserid == data.id ? true : false;

        let param = {
          data,
          key,
          index: i,
          id: this.id,
          canDrag: dragable,
          disabled: true,
          onBeginDrag: () => ({ index: i }),
          onDropped: result => this.sortList(result, i),
          master: this.props.master,
        };

        return editable ? this.editItem(param) : this.defaultItem(param);
      });
    } else {
      return null;
    }
  }
}

/**
 * @description リスト一覧のヘッダー部分
 */

const TableHeader = () => (
  <thead className='table__header'>
    <tr className='table__label'>
      <td className='value-table value-table--table__label'>
        <div className='value-table__label' />
      </td>
      <td className='value-table value-table--table__label'>
        <div className='value-table__label'>支店</div>
      </td>
      <td className='value-table value-table--table__label'>
        <div className='value-table__label'>ユーザー種別</div>
      </td>
      <td className='value-table value-table--table__label'>
        <div className='value-table__label'>氏名</div>
      </td>
      <td className='value-table value-table--table__label'>
        <div className='value-table__label'>メールアドレス</div>
      </td>
      <td className='value-table value-table--table__label'>
        <div className='value-table__label'>役職</div>
      </td>
      <td className='value-table value-table--table__label'>
        <div className='value-table__label'>承認権限</div>
      </td>
      <td className='value-table value-table--table__label'>
        <div className='value-table__label'>ステータス</div>
      </td>
      <td className='value-table value-table--table__label'>
        <div className='value-table__label' />
      </td>
      <td className='value-table value-table--table__label'>
        <div className='value-table__label' />
      </td>
    </tr>
  </thead>
);

/**
 * @description Table Item コンポーネント
 *
 */
class TableItem extends React.Component {
  constructor(props) {
    super(props);
  }

  // eslint-disable-next-line no-unused-vars
  componentWillReceiveProps(nextProps) {
    //console.log("テーブルアイテム " , nextProps );
  }

  onEndDrag(drop_result, props, monitor, component) {
    this.setState({ canDrag: false });
    if (this.props.onEndDrag) {
      return this.props.onEndDrag(drop_result, props, monitor, component);
    }
  }

  onDropped(dropProps, monitor, dropComponent) {
    if (this.props.onDropped) {
      return this.props.onDropped(dropProps, monitor, dropComponent);
    }
  }

  onBeginDrag(props, monitor, component) {
    if (this.props.onBeginDrag) {
      return this.props.onBeginDrag(props, monitor, component);
    }
  }

  /**
   * @description ドラッグ＆ドロップできるようにラップする
   * @param {React.ReactElement} elements
   */
  setWrapperDnd(elements) {
    if (this.props.canDrag) {
      return (
        <DragSourceAndDropTarget
          id={this.props.id}
          onDropped={this.onDropped.bind(this)}
          onBeginDrag={this.onBeginDrag.bind(this)}
          onEndDrag={this.onEndDrag.bind(this)}
          canDrag={this.props.canDrag}
        >
          {elements}
        </DragSourceAndDropTarget>
      );
    }

    return elements;
  }

  setOptionLevel(data) {
    if (data.approval_level == 1) {
      return 'レベル1';
    } else if (data.approval_level == 2) {
      return 'レベル2';
    } else if (data.approval_level == 3) {
      return 'レベル3';
    } else if (data.approval_level == 4) {
      return 'レベル4';
    } else {
      return '--';
    }
  }

  /**
   * ユーザー種別
   */
  setUserType(data) {
    //本社管理者=2,支店管理者=3,現場監督=4
    if (data.role_code == USER_ROLES.prime.id) {
      return USER_ROLES.prime.name;
    } else if (data.role_code == USER_ROLES.branch.id) {
      return USER_ROLES.branch.name;
    } else if (data.role_code == USER_ROLES.manager.id) {
      return USER_ROLES.manager.name;
    }
  }

  renderStatus(data, modeEditUser = false) {
    if (isPrimeRoleId(data.role_code)) {
      return;
    }

    if (data.block_flag === 1) {
      return (
        <div className='status--mid--blocked'>
          {USER_BOX_STATUS.blocked.text}
        </div>
      );
    }

    const { handleOpenPopupChangeStatus, editUserId, canDrag } = this.props;
    const blockedAt = _.get(data, 'blocked_at');
    let handleClick = null;
    if (_.isFunction(handleOpenPopupChangeStatus) && !editUserId) {
      handleClick = () => {
        if (!canDrag) {
          handleOpenPopupChangeStatus(data);
        }
      };
    }
    const classClickable =
      !modeEditUser && !editUserId && !canDrag ? 'clickable' : '';
    const className = blockedAt
      ? `status--mid ${classClickable}`
      : `status--mid--caution ${classClickable}`;
    const statusText = blockedAt
      ? USER_BOX_STATUS.deactivate.text
      : USER_BOX_STATUS.active.text;

    return (
      <div className={className} onClick={handleClick}>
        {statusText}
      </div>
    );
  }

  render() {
    const { data } = this.props;

    const dragable = () => {
      return this.props.canDrag
        ? { display: 'table-cell' }
        : { display: 'none' };
    };
    const undragable = () => {
      const my_role_id = localStorage.getItem('role_id');
      //上位のロールは編集できない
      if (data.role_code < my_role_id) {
        return { display: 'none' };
      }
      return !this.props.canDrag
        ? { display: 'table-cell' }
        : { display: 'none' };
    };

    return this.setWrapperDnd(
      <tr className='table__item'>
        <td className='value-table value-table--btn-drag'>
          <div className='value-table__icon'>
            <button
              style={dragable()}
              className='btn-icon--sm'
              onMouseDown={() => {
                this.setState({ canDrag: true });
              }}
            >
              <i className='i-drag i-3x' />
            </button>
          </div>
        </td>
        <td className='value-table construction-list-value-table__address'>
          <span className='label'>支店</span>
          <div className='value-table__txt--10'>
            {data.company_branch_name || ''}
          </div>
        </td>
        <td className='value-table construction-list-value-table__branch-name'>
          <span className='label'>ユーザー種別</span>
          <div className='value-table__txt--5'>{this.setUserType(data)}</div>
        </td>
        <td className='value-table construction-list-value-table__name'>
          <span className='label'>氏名</span>
          <div className='value-table__txt--10'>
            {`${data.user_name_sei} ${data.user_name_mei}` || ''}
          </div>
        </td>
        <td className='value-table construction-list-value-table__date fieldtree-list-value-table__email'>
          <span className='label'>メールアドレス</span>
          <div className='value-table__txt--10'>{data.email || ''}</div>
        </td>
        <td className='value-table construction-list-value-table__date
          fieldtree-list-value-table__position fieldtree-list-value-table__position--fixed-width'>
          <span className='label'>役職</span>
          <div className='value-table__txt--7'>
            {data.position_name || '--'}
          </div>
        </td>
        <td className='value-table construction-list-value-table__date fieldtree-list-value-table__level'>
          <span className='label'>承認権限</span>
          <div className='value-table__txt--5'>{this.setOptionLevel(data)}</div>
        </td>
        <td className='value-table construction-list-value-table__option'>
          <span className='label'>ステータス</span>
          <div className='value-table__normal'>{this.renderStatus(data)}</div>
        </td>
        <td className='--col-lg-2 --col-xl-2 --col-md-2 --col-xs-3' />
        <td className='value-table construction-list-value-table__edit'>
          <div className='value-table__button-3'>
            {data.block_flag === 0 && (
              <button
                style={undragable()}
                className='btn--sm--stay'
                onClick={() =>
                  EventMg.trigger(
                    FIELD_TREE_CONSTRUCTOR_BOX.CHANGE_FORM_SHOW,
                    data
                  )
                }
              >
                編集
              </button>
            )}
          </div>
        </td>
      </tr>
    );
  }
}

/**
 * @description Table Item コンポーネント
 *
 */
class EditTableItem extends TableItem {
  constructor(props) {
    super(props);
    this.state = {
      canDrag: false,
      user_id: localStorage.getItem('user_id'),
      validationErrorMap: {},
    };
    this.position_id = null;
    this.approval_flag = null;
    this.block_flag = null;
  }

  validate = (propName, value) => {
    const isError = _.size(value) === 0;
    this.setState(prevState => ({
      validationErrorMap: {
        ...prevState.validationErrorMap,
        [propName]: isError,
      },
    }));
    return isError;
  };

  getIsError = propName => {
    return this.state.validationErrorMap[propName];
  };

  getErrorMessage(propName) {
    const isError = this.getIsError(propName);
    if (isError) {
      return (
        <div className='validate-message show'>
          {messageUtility.getMessage('E-000-010')}
        </div>
      );
    } else {
      return null;
    }
  }

  render() {
    const { data } = this.props;
    const deletestyle =
      this.state.user_id == data.user_id
        ? { display: 'none' }
        : { display: 'inline-block' };

    return (
      <tr key={data.id} className='table__item editable'>
        <td className='value-table value-table--btn-drag'>
          <div className='value-table__icon ' />
        </td>
        <td className='value-table construction-list-value-table__address'>
          <span className='label'>支店</span>
          <div className='value-table__txt--10'>
            {data.company_branch_name || ''}
          </div>
        </td>
        <td className='value-table construction-list-value-table__branch-name'>
          <span className='label'>ユーザー種別</span>
          <div className='value-table__txt--5'>{this.setUserType(data)}</div>
        </td>
        <td className='value-table construction-list-value-table__name'>
          <span className='label'>氏名</span>
          <div className='value-table__txt--10'>
            {`${data.user_name_sei} ${data.user_name_mei}` || ''}
          </div>
        </td>
        <td className='value-table construction-list-value-table__date fieldtree-list-value-table__email'>
          <span className='label'>メールアドレス</span>
          <div className='value-table__txt--10'>{data.email || ''}</div>
        </td>
        <td className='value-table value-table--jobposition value-table--jobposition--fixed-width'>
          <div className='value-table__txt--10 sys-tooltip'>
            <Options
              ref={e => {
                this.position_id = e;
              }}
              position
              selected={data.position_id || ''}
              selectedName={data.position_name || ''}
              callback={() => {}}
              onBlur={value => {
                this.validate('position_id', value);
              }}
              values={this.props.master.positions}
            />
          </div>
          {this.getErrorMessage('position_id')}
        </td>
        <td className='value-table value-table--approval'>
          <div className='value-table__txt--10 sys-tooltip'>
            <Options
              ref={e => {
                this.approval_level = e;
              }}
              selected={data.approval_level || ''}
              callback={() => {}}
              onBlur={value => {
                this.validate('approval_level', value);
              }}
              values={[
                { id: 1, name: 'レベル1' },
                { id: 2, name: 'レベル2' },
                { id: 3, name: 'レベル3' },
                { id: 4, name: 'レベル4' },
              ]}
            />
          </div>
          {this.getErrorMessage('approval_level')}
        </td>
        <td className='value-table construction-list-value-table__option'>
          <span className='label'>ステータス</span>
          <div className='value-table__normal'>
            {this.renderStatus(data, true)}
          </div>
        </td>
        <td className='--col-lg-2 --col-xl-2 --col-md-2 --col-xs-3' />
        <td className='value-table value-table--button'>
          <div className='value-table__button-3'>
            <button
              className='btn--sm--negative'
              style={deletestyle}
              onClick={() =>
                EventMg.trigger(FIELD_TREE_CONSTRUCTOR_BOX.DELETE_USER, data)
              }
            >
              削除
            </button>
            <button
              className='btn--sm--sub'
              onClick={() =>
                EventMg.trigger(
                  FIELD_TREE_CONSTRUCTOR_BOX.CHANGE_FORM_SHOW,
                  null
                )
              }
            >
              戻る
            </button>
            <button
              className='btn--sm--effective'
              onClick={() => {
                let _data = _.clone(data);
                _data.position_id = this.position_id.refs.select.value;
                // _data.block_flag = this.block_flag.refs.select.value;
                _data.approval_level = this.approval_level.refs.select.value;
                _data.approval_flag = data.approval_flag;

                const errors = [
                  this.validate('position_id', _data.position_id),
                  this.validate('approval_level', _data.approval_level),
                ];

                if (_.every(errors, isError => !isError)) {
                  EventMg.trigger(
                    FIELD_TREE_CONSTRUCTOR_BOX.UPDATE_FORM,
                    _data
                  );
                }
              }}
            >
              保存
            </button>
          </div>
        </td>
      </tr>
    );
  }
}

class Options extends React.Component {
  render() {
    return (
      <select
        ref={'select'}
        defaultValue={this.props.selected}
        onChange={e => this.props.callback(e)}
        onBlur={e => this.props.onBlur(e.target.value)}
      >
        {/* 役職プルダウンにて、未使用になった役職が選択されていても
        プルダウンのラベルには選択時の名前を表示する */}
        {this.props.position === true && this.props.selectedName !== '' ? (
          <option
            value={this.props.selected}
            disabled
            selected
            style={{ display: 'none' }}
          >
            {this.props.selectedName}
          </option>
        ) : null}
        <option value='' disabled>
          --
        </option>
        {_.map(this.props.values, val => {
          return (
            <option key={val.id} value={val.id}>
              {val.name}
            </option>
          );
        })}
      </select>
    );
  }
}

const TitleHeader = param => {
  const title = () => {
    if (_.has(param.jv, 'name')) {
      return `${param.jv.name} ${param.jv.company_branch_name}の確認・編集 - 現場監督一覧`;
    }
    if (_.some(param.company)) {
      return `${param.company.company_name} ${param.company.name}の確認・編集 - 現場監督一覧`;
    }
  };

  return <MasterPageHeader title={title()} onClose={param.close} />;
};

class HeaderMenu extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      editmode: false,
      dragmode: false,
    };

    EventMg.addEventListener(
      FIELD_TREE_CONSTRUCTOR_BOX.CHANGE_FORM_SHOW,
      data => {
        this.setState({ editmode: data ? true : false });
      }
    );
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      dragmode: nextProps.canDrag,
    });
  }

  mode() {
    return {
      drag: () => {
        if (this.state.dragmode) {
          return { display: 'flex' };
        } else {
          return { display: 'none' };
        }
      },
      edit: () => {
        if (this.state.editmode) {
          return { display: 'flex' };
        } else {
          return { display: 'none' };
        }
      },
      default: () => {
        if (!this.state.editmode && !this.state.dragmode) {
          return { display: 'flex' };
        } else {
          return { display: 'none' };
        }
      },
    };
  }

  render() {
    return (
      <div className='master-slide-view__menu'>
        <ul className='btn-menu' style={this.mode().default()}>
          <li className='btn-menu__item'>
            <button
              className='btn'
              onClick={() => {
                dialogLoader.show(dialog.ForemanSearch, {
                  state: {
                    fieldId: this.props.fieldId,
                  },
                  callback: {
                    back: () => {
                      dialogLoader.close();
                    },
                    submit: param => {
                      EventMg.trigger(
                        FIELD_TREE_CONSTRUCTOR_BOX.ADD_FROM_SEARCH,
                        param
                      );
                    },
                  },
                });
              }}
            >
              検索して追加
            </button>
          </li>
          <li className='btn-menu__item'>
            <button
              className='btn'
              onClick={() => {
                EventMg.trigger(FIELD_TREE_CONSTRUCTOR_BOX.NEW_FORM);
              }}
            >
              新規作成
            </button>
          </li>
          {this.props.showDragItem ? (
            <li className='btn-menu__item sm--hidden '>
              <div className='segment-line' />
            </li>
          ) : null}
          <ul className='btn-menu'>
            <TouchDeviceInvisible>
              <li className='btn-menu__item'>
                {this.props.showDragItem ? (
                  <button
                    className='btn--sub'
                    onClick={() => {
                      EventMg.trigger(FIELD_TREE_CONSTRUCTOR_BOX.DRAG_ITEM);
                      this.props.menuView();
                    }}
                  >
                    並び順を変更する
                  </button>
                ) : null}
              </li>
            </TouchDeviceInvisible>
            <li className='btn-menu__item --fx-auto' />
            <li className='btn-menu__item'>
              <button
                className='btn--sub'
                onClick={() => {
                  EventMg.trigger(FIELD_TREE_CONSTRUCTOR_BOX.CSV_EXPORT);
                }}
              >
                表示データをCSV出力
              </button>
            </li>
          </ul>
        </ul>
        <ul className='btn-menu' style={this.mode().drag()}>
          <li className='btn-menu__item'>
            <button
              className='btn'
              onClick={() => {
                EventMg.trigger(FIELD_TREE_CONSTRUCTOR_BOX.SAVE_ORDER, true);
                this.props.menuView();
              }}
            >
              保存
            </button>
          </li>
          <li className='btn-menu__item --fx-auto' />
        </ul>
        <ul className='btn-menu' style={this.mode().edit()}>
          <li className='btn-menu__item --fx-auto' />
          <li className='btn-menu__item'>
            <button
              className='btn--sub'
              onClick={() => {
                EventMg.trigger(FIELD_TREE_CONSTRUCTOR_BOX.CSV_EXPORT);
              }}
            >
              表示データをCSV出力
            </button>
          </li>
        </ul>
      </div>
    );
  }
}

const SearchFormHeader = ({ isOpen, total }) => (
  <div className='search-form__header'>
    <div className='search-form__title'>
      検索条件（検索結果
      <span className='bold'>{total}</span>
      件)
    </div>
    <button
      id='accordion-toggle'
      className={isOpen ? 'accordion__btn show' : 'accordion__btn'}
      onClick={() =>
        EventMg.trigger(FIELD_TREE_CONSTRUCTOR_BOX.SEARCH_FORM_OPEN)
      }
    />
    <button
      className='btn-text--sm'
      onClick={() => EventMg.trigger(FIELD_TREE_CONSTRUCTOR_BOX.SEARCH_CLEAR)}
    >
      検索条件クリア
    </button>
  </div>
);

const SearchFormRadio = ({ label, name, value, checked }) => (
  <div className='element__item'>
    <label className='radio'>
      <input
        name={`radio-${name}`}
        type='radio'
        checked={checked}
        onChange={() =>
          EventMg.trigger(
            FIELD_TREE_CONSTRUCTOR_BOX.SEARCH_FORM_RADIO,
            name,
            value
          )
        }
      />
      <i className='i-2x' />
      <span>{label}</span>
    </label>
  </div>
);

const SearchFormElement = ({ label, children, eleClass }) => (
  <div className='form-element'>
    <div className='form-element__label'>
      <span className='label'>{label}</span>
    </div>
    <div className={eleClass}>{children}</div>
  </div>
);



// WEBPACK FOOTER //
// ./src/pages/FieldTreeContractorBox.jsx